import React, { Component } from 'react';
import { Navbar, Nav, Container, Jumbotron, Row, Col, Button } from 'react-bootstrap';

import { withRouter } from './withRouter.js';
import Syllabus from './Syllabus.js';
import People from './People.js';
import Policies from './Policies.js';

import { acknowledgement, course_full_name, course_location, semester, course_number, course_objective, course_objective_long, course_short_name, course_sub_name, course_time } from './config.js';
import Howitworks from './Howitwork.js';


import { format } from 'date-fns';
class Home extends Component {

    render() {
        return (
            <>  <div id='header'> <figcaption>figure: https://d3js.org/</figcaption></div>
                  <Container className='notification'> 
                    📢  Our  <a  href="/CMSC471-Spring25/#/gallery" target="_blank">  final project gallery </a> is live! Come explore 26 amazing interactive visualization projects built by students.
                </Container>
                <Navbar bg="white" expand="lg">
                    <Container className="mt-1">
                        <Navbar.Brand href="#">{course_number}</Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ml-auto">
                                <Nav.Link href="#">Home</Nav.Link>
                                <Nav.Link href="#howitworks">HTW</Nav.Link>
                                <Nav.Link href="#syllabus">Syllabus</Nav.Link>
                                <Nav.Link href="#crew">Crew</Nav.Link>
                                <Nav.Link href="#policies">Policies</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>

                <Container className="" style={{ 'top': 0, 'postiion': 'absolute' }}>
                    <div className="text-left">
                        <h1 className="display-4">{course_full_name}</h1>
                        <p className="lead">{course_sub_name}</p>

                        <h6> Time: <span className='color'>{course_time}</span> | Location: <span className='color'>{course_location}</span> | Semester: <span className='color'>{semester}</span> </h6>
                        <p> Last update: {format(new Date(document.lastModified), 'MM/dd/yyyy kk:mm')}
                        </p>
                    </div>


                    {/* <Row className='desktop-only' >
                            <Col lg={4}><img src={forecasts2020} className='headimage'></img> <figcaption>https://projects.fivethirtyeight.com/2020-election-forecast/</figcaption> </Col>
                            <Col lg={4}><img src={ggdist} className='headimage'></img> <figcaption>https://mjskay.github.io/ggdist/</figcaption> </Col>
                            <Col lg={4}><img src={llm} className='headimage'></img><figcaption>https://analyticsindiamag.com/ai-origins-evolution/the-rise-of-lame-llm-papers/</figcaption> </Col>

                        </Row> */}



                    <p dangerouslySetInnerHTML={{ __html: course_objective_long }}></p>
                    {/* <p dangerouslySetInnerHTML={{__html:course_objective}}></p> */}

                    Useful links: <a href="https://umd.instructure.com/courses/1378130" class='button-detail2' target='_blank'>Canvas</a>  <a href="https://piazza.com/umd/spring2025/cmsc471" class='button-detail2' target='_blank'>Piazza</a>


                    <hr className="my-4" />
                    <Howitworks />

                    <Syllabus />

                    <People />

                    <Policies />

                    <>
                        <h2 id='policies'>Acknowledgements</h2>
                        <p dangerouslySetInnerHTML={{ __html: acknowledgement }}></p>
                    </>

                    {/* </div> */}


                </Container>

                {/* </div> */}
                <footer className="footer mt-auto py-3 bg-light">
                    <Container className="text-center">
                        <span className="text-muted">© 2024 University of Maryland, College Park.</span>
                    </Container>
                </footer>
            </>
        )
    }
}



export default withRouter(Home);